import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BarTimeValue from '../Charts/BarTimeValue';
import { namedColor, transparentize } from 'Chart/ChartUtils';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from "@mui/material/Grid";
import config from '../../../../config';
import DecimationTimeValue from '../Charts/DecimetionTimeValue';
import ChartTimeValue from '../Charts/ChartTimeValue';
import { borderColor } from '@mui/system';
import Steps from "layouts/pages/widgets/components/Steps";
import FullBody from "layouts/pages/widgets/components/FullBody";
import { DIAGRAM_COLORS } from 'diagrammColors';


const SpeedTravelComp = ({ params }) => {
    const { t } = useTranslation();
    console.log("SpeedTravelComp", params)

    const getNameById = (id) => {
        const item = params.selectedDetectors.find(item => item.id === id);
        return item ? item.name : null; // Return name if found, otherwise null
    };

    const [chartData, setChartData] = useState();
    const [accurasyChart, setAccurasyChart] = useState();
    const [intersectionChart, setIntersectionChart] = useState();
    const [accurasy, setAccuracy] = useState([]);
    const [noRouteData, setNoRouteData] = useState(false)

    useEffect(() => {
        const keycloakToken = localStorage.getItem('keycloak-token');
        async function fetchData() {
            try {
                let getUrl = "";
                let header = "open_imet";
                if (params.detector === "tomtomfcd") {
                    getUrl = config.ENDPOINTS_URL + `/rpc/th_tomtom_completeness_per_route?start_ts=${params.dates.from}&end_ts=${params.dates.to}&route_id=${params.selectedDetectors[0].id.toString()}`
                    header = "route_monitoring";
                } else if (params.detector === "taxifcd") {
                    getUrl = config.ENDPOINTS_URL + `/rpc/th_taxi_completeness_per_route?start_time=${params.dates.from}&end_time=${params.dates.to}&route_id=${params.selectedDetectors[0].id.toString()}`
                } else {
                    getUrl = config.ENDPOINTS_URL + `/rpc/th_bt_completeness_per_route?start_time=${params.dates.from}&end_time=${params.dates.to}&route_id=${params.selectedDetectors[0].id.toString()}`
                }
                const response = await axios(getUrl, {
                    headers: {
                        "Accept-Profile": header
                    }
                });
                if (!response.data) {
                    setNoRouteData(true)
                } else {
                    setNoRouteData(false);
                    let data;
                    if (params.detector === "tomtomfcd") {
                        data = response.data.map((item) => ({
                            x: new Date(item.ts).toLocaleString('en-GB'), // Format date to be readable
                            y: item.completeness,
                        }));
                    } else if (params.detector === "taxifcd") {
                        data = response.data.map((item) => ({
                            x: new Date(item.time_slot).toLocaleString('en-GB'), // Format date to be readable
                            y: item.competeness,
                        }));
                    } else {
                        data = response.data.map((item) => ({
                            x: new Date(item.time_slot).toLocaleString('en-GB'), // Format date to be readable
                            y: item.competeness,
                        }));
                    }
                    const chartD = {
                        datasets: [
                            {
                                label: params.selectedDetectors[0].name,
                                data: data,
                                backgroundColor: DIAGRAM_COLORS[0],
                                borderWidth: 0, // Removes the connecting line                            
                                tension: 0.4, // Line smoothing
                                minBarLength: 7, // Ensures bars are visible even when value is 0
                            }
                        ]
                    };
                    setChartData(chartD);
                }
            } catch (error) {
                console.log(error)
            }
        }
        async function fetchDataCompare() {
            try {
                let getUrl = "";
                let header = "open_imet";
                if (params.detector === "tomtomfcd") {
                    getUrl = config.ENDPOINTS_URL + `/rpc/th_tomtom_completeness_per_route?p_start_time=${params.dates.from}&p_end_time=${params.dates.to}&p_path_id=${params.selectedDetectors[0].id.toString()}`
                    header = "route_monitoring";
                } else if (params.detector === "taxifcd") {
                    getUrl = config.ENDPOINTS_URL + `/rpc/th_realtime_fcd_vs_tomtom?p_start_time=${params.dates.from}&p_end_time=${params.dates.to}&p_path_id=${params.selectedDetectors[0].id.toString()}`
                } else {
                    getUrl = config.ENDPOINTS_URL + `/rpc/th_realtime_bt_vs_tomtom?p_start_time=${params.dates.from}&p_end_time=${params.dates.to}&p_path_id=${params.selectedDetectors[0].id.toString()}`
                }
                const response = await axios(getUrl, {
                    headers: {
                        "Accept-Profile": header
                    }
                });
                if (!response.data) {
                    setNoRouteData(true)
                } else {
                    setNoRouteData(false);
                    let data1;
                    let data2;
                    let title = "";

                    if (params.detector === "tomtomfcd") {

                    } else if (params.detector === "taxifcd") {
                        title = "Taxi fcd"; // technical data-source identifier, not translated
                        data1 = response.data.filter(item => item.source === "tt_fcd")
                            //.sort((a, b) => new Date(a.ts) - new Date(b.ts)) // Sort by timestamp, oldest first
                            .map(item => ({
                                x: new Date(item.ts).toLocaleString('en-GB'), // Format date to be readable
                                y: item.duration,
                            }));
                        data2 = response.data.filter(item => item.source === "outputs_route_monitoring_path_bt")
                            //.sort((a, b) => new Date(a.ts) - new Date(b.ts)) // Sort by timestamp, oldest first
                            .map(item => ({
                                x: new Date(item.ts).toLocaleString('en-GB'), // Format date to be readable
                                y: item.duration,
                            }));
                    } else {
                        title = "Bluetooth"; // technical data-source identifier, not translated
                        data1 = response.data.filter(item => item.source === "tt_bluetooth")
                            //.sort((a, b) => new Date(a.ts) - new Date(b.ts)) // Sort by timestamp, oldest first
                            .map(item => ({
                                x: new Date(item.ts).toLocaleString('en-GB'), // Format date to be readable
                                y: item.duration,
                            }));

                        data2 = response.data.filter(item => item.source === "outputs_route_monitoring_path_bt")
                            .sort((a, b) => new Date(a.ts) - new Date(b.ts)) // Sort by timestamp, oldest first
                            .map(item => ({
                                x: new Date(item.ts).toLocaleString('en-GB'), // Format date to be readable
                                y: item.duration,
                            }));

                    }
                    const chartD = {
                        datasets: [
                            {
                                label: "TomTom",
                                data: data2,
                                backgroundColor: transparentize(namedColor(1), 0),
                                pointBorderColor: transparentize(namedColor(1), 0),
                                borderColor: transparentize(namedColor(1), 0),
                                borderWidth: 2, // Removes the connecting line                            
                                tension: 0, // Line smoothing
                                pointRadius: 4, // Adds visible points on the line
                                pointHoverRadius: 6, // Increases size on hover
                                spanGaps: true // Ensure line connects all points
                            },
                            {
                                label: title,
                                data: data1,
                                backgroundColor: transparentize(namedColor(0), 0),
                                pointBorderColor: transparentize(namedColor(0), 0),
                                borderColor: transparentize(namedColor(0), 0),
                                borderWidth: 2, // Removes the connecting line                            
                                tension: 0, // Line smoothing
                                pointRadius: 4, // Adds visible points on the line
                                pointHoverRadius: 6, // Increases size on hover
                                spanGaps: true // Ensure line connects all points
                            }

                        ]
                    };
                    setAccurasyChart(chartD);
                }
            } catch (error) {
                console.log(error)
            }
        }
        async function fetchIntersectionData() {
            try {
                const interData = await axios.get(config.SYNCHROEU_URL + `/pg_junction_thess/rpc/th_accuracy_detectors_vs_tom?p_start_time=${params.dates.from}&p_end_time=${params.dates.to}&p_intersection_id=${params.selectedDetectors[0].id.toString()}`, {
                    headers: {
                        Authorization: `Bearer ${keycloakToken}`,
                        "Accept-profile": "public"
                    }
                });

                setIntersectionChart(interData.data)
            } catch (err) {
                console.log(err)
            }
        }
        async function fetchAccurasy() {
            const KT = localStorage.getItem('keycloak-token');

            try {
                const accurasyData = await axios.get(config.SYNCHROEU_URL + `/pg_junction_thess/rpc/th_mape_detectors_tom?p_start_time=${params.dates.from}&p_end_time=${params.dates.to}&p_intersection_id=${params.selectedDetectors[0].id.toString()}`, {
                    headers: {
                        "Authorization": `Bearer ${KT}`   
                    }
                });
                if(accurasyData){
                    setAccuracy(accurasyData.data)
                }
            } catch (err) {
                console.log(err)
                setAccuracy([])
            }
        }
        if (params.location === "Routes" && params.selectedDetectors.length > 0) {
            fetchData();
            fetchDataCompare();
        }
        if (params.location === "Intersections" && params.selectedDetectors.length > 0) {
            fetchAccurasy();
            fetchIntersectionData();
        }
    }, [params])


    const getIntetsectionDiagrams = () => {
        let returnedData = []
        intersectionChart.map((item, index) => {
            let data1 = null;
            let data2 = null;
            data1 = item.map((item1) => ({
                x: new Date(item1.timestamp).toLocaleString('en-GB'), // Format date to be readable
                y: item1.flow,
            }));
            data2 = item.map((item2) => ({
                x: new Date(item2.timestamp).toLocaleString('en-GB'), // Format date to be readable
                y: item2.volumeperhour,
            }));
            const chartD = {
                datasets: [
                    {
                        label: t("dataQuality.speedTravelComp.vehiclePerHourRcm"),
                        data: data1,
                        backgroundColor: transparentize(namedColor(1), 0),
                        pointBorderColor: transparentize(namedColor(1), 0),
                        borderColor: transparentize(namedColor(1), 0),
                        borderWidth: 2, // Removes the connecting line                            
                        tension: 0, // Line smoothing
                        pointRadius: 3, // Adds visible points on the line
                        pointHoverRadius: 6, // Increases size on hover
                        spanGaps: true // Ensure line connects all points
                    },
                    {
                        label: t("dataQuality.speedTravelComp.vehiclePerHourTomTom"),
                        data: data2,
                        backgroundColor: transparentize(namedColor(0), 0),
                        pointBorderColor: transparentize(namedColor(0), 0),
                        borderColor: transparentize(namedColor(0), 0),
                        borderWidth: 2, // Removes the connecting line                            
                        tension: 0, // Line smoothing
                        pointRadius: 3, // Adds visible points on the line
                        pointHoverRadius: 6, // Increases size on hover
                        spanGaps: true // Ensure line connects all points
                    }
                ]
            };
            let accurasyValue = accurasy.find((x) => (x.link_id === item[0].link_id));
            let finalVal = "100%"
            if(typeof accurasyValue !== "undefined"){
                finalVal = String(accurasyValue.mape) + "%";
            }else{
                finalVal = t("dataQuality.speedTravelComp.error")
            }
            returnedData.push(
                <>
                    <Grid container spacing={3}  style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <Grid item xs={12} md={10} >
                            <ChartTimeValue chartData={chartD} title={item[0].name} />
                        </Grid>
                        <Grid item xs={12} md={2} >
                            <FullBody title={"MAPE (%)"} description={t("dataQuality.speedTravelComp.mapeDescription", { value: finalVal })} value={finalVal} />
                        </Grid>
                    </Grid>

                </>
            )
        })
        return returnedData;
    }

    return (
        <Grid container={true} p={2}>
            {
                params.location === "Routes" && params.selectedDetectors.length > 0 &&
                <div className='rawContainerDiagrams'>
                    <div className='diagrammHeadTitle'>{t("dataQuality.speedTravelComp.completenessPerRoute")}</div>
                    {chartData ? <div className='detectorDiagramsContainer'><BarTimeValue chartData={chartData} title="" /></div> : <div className='rawContainerCenteredH'>{noRouteData ? <span>{t("dataQuality.detectorComp.noDataForCombo")}</span> : <CircularProgress />}</div>}
                </div>
            }
            <div className='rawContainerDiagrams'>
                {
                    params.detector !== "tomtomfcd" &&
                    <>{accurasyChart ? <div className='detectorDiagramsContainer'><ChartTimeValue chartData={accurasyChart} title="" /></div> : <div className='rawContainerCenteredH'>{noRouteData ? <span>{t("dataQuality.detectorComp.noDataForCombo")}</span> : <CircularProgress />}</div>}</>
                }
            </div>
            {
                (params.location === "Intersections" && params.selectedDetectors.length > 0 && intersectionChart && accurasy) &&
                getIntetsectionDiagrams()

            }
        </Grid>
    );
};

export default SpeedTravelComp;